import { AgmInfoWindow, MapsAPILoader, AgmMap } from "@agm/core";
import {
  Component,
  Injector,
  ChangeDetectionStrategy,
  ViewChild,
  Input,
} from "@angular/core";
import {
  FPBaseComponent,
  IFPComponentData,
  FPFormBaseComponent,
} from "@fp/components/base";
import { Utils } from "@fp/helpers";
import { DataResult } from "@fp/models";
import { SuburbService, MessageBox, CommonService, HttpDAO } from "@fp/services";
import { MapFacilityData } from "@fp/models/map-facility-data";
import { DialogResult } from "@fp/components/common-dialog/common-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ActivityConstant } from "@fp/constant/activity-constants";
import { FilterSearchResultPopupComponent } from "@fp/filter-search-result-popup/filter-search-result-popup.component";
import { HttpClient } from "@angular/common/http";
import { merge, of as observableOf } from "rxjs";
import { startWith, switchMap, map, catchError } from "rxjs/operators";
import { APIConstant } from "@fp/constant";

declare const google: any;

interface Location {
  lat: number;
  lng: number;
  zoom: number;
}

@Component({
  selector: "app-google-map-page-view",
  templateUrl: "./google-map-page-view.component.html",
  styleUrls: ["./google-map-page-view.component.css"],
  providers: [
    FPBaseComponent.provideExisting(GoogleMapPageViewComponent),
    FPFormBaseComponent.provideExisting(GoogleMapPageViewComponent),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleMapPageViewComponent extends FPBaseComponent<IFPComponentData> {
  geocoder: any;
  ranFac = 0;
  buttonTitle: string = "List View";
  visible: boolean = false;
  public location: Location = {
    lat: -23.698,
    lng: 133.8807,
    zoom: 5,
  };
  public dataSource: Array<MapFacilityData> = []; // original data source from backend
  public filteredDataSource: Array<MapFacilityData> = []; // data source displayed on facility list
  public mapDataSource: Array<MapFacilityData> = []; // data source displayed on maps
  public singleFacDataSource: Array<MapFacilityData> = [];
  public multiFacDataSource: Array<MapFacilityData> = [];
  iconUrl = ActivityConstant.DEFAULT_ICONURL;
  mapLocationSearch = "";
  listLocationFilter = "";
  checkedName = "";
  public mapIsLoading: boolean = false;
  private previousInfoWindow: AgmInfoWindow = null;
  disableSearchFacByArea = false;
  disableSearchFacByName = false;
  isChecked = false;
  Utils = Utils;
  @Input() isAustralia: boolean;

  private httpdao2: HttpDAO | null;
  longi: number;
  lati: number;

  @ViewChild("map") private map: AgmMap;

  constructor(
    private router: Router,
    private http: HttpClient,
    injector: Injector,
    public commonservice: CommonService,
    private suburbSvc: SuburbService, // service that contains the function that calls facilities
    public mapsApiLoader: MapsAPILoader, // private zone: NgZone
    private route: ActivatedRoute
  ) {
    super(injector);

    this.mapsApiLoader = mapsApiLoader;
    this.mapsApiLoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });

  }

  ngOnChanges() {
    if (this.isAustralia == false) {
      this.location = {
        lat: -40,
        lng: 174,
        zoom: 5,
      };
    } else {
      this.location = {
        lat: -23.698,
        lng: 133.8807,
        zoom: 5,
      };
    }
  }

  // checks to see if theres multiple facilities in same location and adds factor to allow both dots to appear on map
  checkIfDuplicates(facility: MapFacilityData, lats, longs): any[] {
    let count = 0;
    const locCheck = true;
    let sameLoc = false;
    let newLat = 0;
    for (let i = 0; i < lats.length; i++) {
      if (
        facility.Address.Latitude === lats[i] &&
        facility.Address.Longitude === longs[i]
      ) {
        count++;
      }
    }
    if (count > 1) {
      sameLoc = true;
      newLat = +facility.Address.Latitude - 0.00002 * this.ranFac;
      this.ranFac++;
    } else {
      sameLoc = false;
    }
    return [locCheck, sameLoc, newLat];
  }

  // marks variables LocationChecked and SameLocation in the actual facility variable based on checkIfDuplicates function output
  duplicateLocationCheck() {
    this.singleFacDataSource = [];
    this.multiFacDataSource = [];
    let latitudeArray = [];
    let longitudeArray = [];
    this.mapDataSource.forEach((element) => {
      latitudeArray.push(element.Address.Latitude);
      longitudeArray.push(element.Address.Longitude);
    });
    for (let i = 0; i < this.mapDataSource.length; i++) {
      var output;
      if (this.mapDataSource[i].LocationChecked == null) {
        output = this.checkIfDuplicates(
          this.mapDataSource[i],
          latitudeArray,
          longitudeArray
        );
        this.mapDataSource[i].LocationChecked = output[0];
        this.mapDataSource[i].SameLocation = output[1];
      }
      if (!this.mapDataSource[i].SameLocation) {
        this.singleFacDataSource.push(this.mapDataSource[i]);
      } else {
        this.multiFacDataSource.push(this.mapDataSource[i]);
        this.mapDataSource[i].Address.Latitude = "" + output[2];
      }
    }
  }

  clickToMaps(facility: MapFacilityData) {
    this.location.lat = +facility.Address.Latitude;
    this.location.lng = +facility.Address.Longitude;
    this.location.zoom = 16;
    this.changeDetectorRef.detectChanges();
  }

  LoadFacilitiesByMembershipPackageId(id: number, memberId?: number) {
    if (!id) {
      return;
    }
    this.Search("Membership_Package", String(id), String(memberId));
  }

  closePreviousInfoWindow(infoWindow) {
    if (this.previousInfoWindow) {
      this.previousInfoWindow.close();
    }
    this.previousInfoWindow = infoWindow;
  }

  formatTime(time) {
    if (time !== null) {
      const hours = time.split(":")[0];
      const mins = time.split(":")[1];
      return hours + ":" + mins;
    }
  }

  Search(name: string, value: string, memberId?: string) {
    this.mapIsLoading = true;
    if (memberId === undefined || memberId === "undefined" || memberId === "null") {
      memberId = null;
    }
    this.httpdao2 = new HttpDAO(this.http);

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.httpdao2.getSingleDataWithoutToken(
            APIConstant.API_GET_FACILITY_MAPS +
            "?filterType=" +
            name +
            "&filterId=" +
            value +
            "&memberId=" +
            memberId
          );
        }),
        map((data: DataResult<MapFacilityData[]>) => {
          this.mapIsLoading = false;
          if (data.Success) {
            this.dataSource = data.Data;
            this.setToolTip();
            this.previousInfoWindow = null;
            this.filteredDataSource = this.dataSource;
            this.mapDataSource = this.dataSource;
            this.changeDetectorRef.detectChanges();
            this.duplicateLocationCheck();
          } else {
            MessageBox.ShowError(
              this.dialog,
              "Sorry, something went wrong. Let's try that again."
            ).subscribe((res) => {
              if (res.result.toLowerCase() === DialogResult.Ok) {
                window.location.reload();
              }
            });
            this._logger.error(data.Message);
            return observableOf([]);
          }
        }),
        catchError(() => {
          this.mapIsLoading = false;
          return observableOf([]);
        })
      )
      .subscribe();
  }

  public startMapLoadSpinner() {
    this.mapIsLoading = true;
    this.changeDetectorRef.detectChanges();
  }

  setToolTip() {
    if (this.dataSource.length > 0) {
      this.dataSource.forEach((facility) => {
        if (facility.Activities.length > 0) {
          facility.Activities.forEach((activity) => {

            if (activity.ActivityName.toLocaleLowerCase() == ActivityConstant.FACILITY_ACCESSIBLE_OPTIONS.toLocaleLowerCase()) {
              activity.ActivityToolTip = "Accessible Options<br>(See Additional Info)"
            }
            else {
              activity.ActivityToolTip = activity.ActivityName;
            }
          })
        }
      });
    }
  }

  goToListView() {
    this.visible = !this.visible;
    this.buttonTitle = this.visible ? "Map View" : "List View";

    this.mapLocationSearch = "";
    this.mapDataSource = this.dataSource;
    this.mapDataSource = this.mapDataSource.map((item) => {
      return { ...item, IsShownAdditionalInfo: false };
    });
    this.location.zoom = 5
    this.iconUrl = ActivityConstant.DEFAULT_ICONURL;
  }

  searchBarFunctionality() {

    this.iconUrl = ActivityConstant.DEFAULT_ICONURL;

    var isAus = this.isAustralia;
    var country;
    var countryCenterCity;
    var region;

    if (isAus) {
      country = " Australia";
      countryCenterCity = "Alice Springs";
      region = "au";
    } else {
      country = " New Zealand";
      countryCenterCity = "Wellington";
      region = "nz";
    }

    if (this.mapLocationSearch !== "") {
      if (!this.visible) {
        if (this.map.zoom !== 12) {
          this.mapIsLoading = true;
        }
      }

      this.mapDataSource = this.dataSource;
      const zoom = 12;

      const searchInput = this.mapLocationSearch.trim();
      const regexFourDigits = /^\d{4}$/;
      const isPostcode = regexFourDigits.test(searchInput);
      let locationAddress = searchInput;

      if (isPostcode) {
        switch (searchInput) {
          case "2000":
          case "2001":
            locationAddress = "Sydney, NSW";
            break;
          case "2002":
            locationAddress = "World Square, NSW";
            break;
          case "2004":
            locationAddress = "Eastern Suburbs MC, NSW";
            break;

          default:
            locationAddress = searchInput;
            break;
        }
      }

      if (this.visible) {
        this.filteredDataSource = this.dataSource.filter(
          (facility: MapFacilityData) =>
            facility.Postcode.Code === this.mapLocationSearch ||
            facility.Suburb.Name.toLocaleLowerCase() === this.mapLocationSearch.toLocaleLowerCase()
        );

        this.mapDataSource = this.filteredDataSource;
      } else {
        this.findLocation(
          locationAddress + country,
          this.mapLocationSearch,
          zoom,
          region
        );
      }

    } else {
      if (!this.visible) {
        if (this.map.zoom !== 5) {
          this.mapIsLoading = true;
        }
      }


      const zoom = 5;
      this.findLocation(countryCenterCity + country, "N/A", zoom, region);
      this.detectChange();

      this.mapDataSource = this.dataSource;
      this.filteredDataSource = this.dataSource;
    }
  }

  detectChange() {
    this.changeDetectorRef.detectChanges();
  }

  findLocation(address, postcode, zoomInp, region) {
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    var componentRestrictions: any = null;
    var isPostcode = Number(postcode);
    if (isPostcode) {
      componentRestrictions = {
        country: region,
        postalCode: postcode,
      };
    }
    this.geocoder.geocode(
      {
        address: address,
        region: region,
        componentRestrictions: componentRestrictions,
      },
      (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (zoomInp === 12) {
            const latitudeUpper = results[0].geometry.location.lat() + 0.09;
            const latitudeLower = results[0].geometry.location.lat() - 0.09;
            const longitudeUpper = results[0].geometry.location.lng() + 0.105;
            const longitudeLower = results[0].geometry.location.lng() - 0.105;

            this.filteredDataSource = this.dataSource.filter(
              (facility: MapFacilityData) =>
                (+facility.Address.Latitude <= latitudeUpper &&
                  +facility.Address.Latitude >= latitudeLower &&
                  +facility.Address.Longitude <= longitudeUpper &&
                  +facility.Address.Longitude >= longitudeLower) ||
                facility.Postcode.Code === postcode
            );
          }
          this.location.lat = results[0].geometry.location.lat();
          this.location.lng = results[0].geometry.location.lng();
          this.changeDetectorRef.detectChanges();

          this.location.zoom = zoomInp;
          this.mapIsLoading = false;
          this.changeDetectorRef.detectChanges();
        } else {
          this.mapIsLoading = false;
          this.changeDetectorRef.detectChanges();
        }
      }
    );
  }

  openCloseAdditionalInfo(id) {
    var AdditionalInfoObj = this.mapDataSource.find(item => item.FacilityId === id);
    AdditionalInfoObj.IsShownAdditionalInfo = !AdditionalInfoObj.IsShownAdditionalInfo;
  }

  filterSearchResultPopup() {
    this.iconUrl = ActivityConstant.DEFAULT_ICONURL;
    this.mapLocationSearch = "";

    if (this.mapLocationSearch === "") {
      var isAus = this.isAustralia;
      var country;
      var countryCenterCity;
      var region;

      if (isAus) {
        country = " Australia";
        countryCenterCity = "Alice Springs";
        region = "au";
      } else {
        country = " New Zealand";
        countryCenterCity = "Wellington";
        region = "nz";
      }

      if (!this.visible) {
        if (this.map.zoom !== 5) {
          this.mapIsLoading = true;
        }
      }

      const zoom = 5;
      this.findLocation(countryCenterCity + country, "N/A", zoom, region);
      this.detectChange();

      this.mapDataSource = this.dataSource;
      this.filteredDataSource = this.dataSource;
    }
    let dialogRef = this.dialog.open(FilterSearchResultPopupComponent, {
      width: "966px",
      data: {
        dataSource: this.dataSource,
        filteredDataSource: this.filteredDataSource,
        listLocationFilter: this.listLocationFilter,
        disableSearchFacByName: this.disableSearchFacByName,
        isChecked: this.isChecked,
        checkedName: this.checkedName,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        var isAus = this.isAustralia;
        var country;
        var countryCenterCity;
        var region;

        if (isAus) {
          country = " Australia";
          countryCenterCity = "Alice Springs";
          region = "au";
        } else {
          country = " New Zealand";
          countryCenterCity = "Wellington";
          region = "nz";
        }

        if (!this.visible) {
          if (this.map.zoom !== 5) {
            this.mapIsLoading = true;
          }
        }

        this.mapDataSource = result[0].resultMap;
        this.checkedName = result[0].resultChecked;

        if (this.checkedName === ActivityConstant.CYCLING) {
          this.iconUrl = ActivityConstant.CYCLING_ICONURL;
        } else if (this.checkedName === ActivityConstant.GROUP_FITNESS) {
          this.iconUrl = ActivityConstant.GROUP_FITNESS_ICONURL;
        } else if (this.checkedName === ActivityConstant.GYM_ACCESS) {
          this.iconUrl = ActivityConstant.GYM_ACCESS_ICONURL;
        } else if (this.checkedName === ActivityConstant.HIIT) {
          this.iconUrl = ActivityConstant.HIIT_ICONURL;
        } else if (this.checkedName === ActivityConstant.LADIES_ONLY) {
          this.iconUrl = ActivityConstant.LADIES_ONLY_ICONURL;
        } else if (this.checkedName === ActivityConstant.PILATES) {
          this.iconUrl = ActivityConstant.PILATES_ICONURL;
        } else if (this.checkedName === ActivityConstant.POOL) {
          this.iconUrl = ActivityConstant.POOL_ICONURL;
        } else if (this.checkedName === ActivityConstant.YOGA) {
          this.iconUrl = ActivityConstant.YOGA_ICONURL;
        } else if (this.checkedName === ActivityConstant.FACILITY_ACCESSIBLE_OPTIONS) {
          this.iconUrl = ActivityConstant.ACCESSIBLE_OPTIONS_ICONURL;
        } else {
          this.iconUrl = ActivityConstant.DEFAULT_ICONURL;
        }

        const zoom = 5;

        this.findLocation(countryCenterCity + country, "N/A", zoom, region);
      }
    });
  }
}
